import React from "react";
import "./SideBar.css";
import { NavLink } from "react-router-dom";
import { Icon } from "@aws-amplify/ui-react";

export interface NavItemData {
  eventKey?: string;
  title?: string;
  icon?: any;
  to?: any;
  target?: string;
  children?: NavItemData[];
}

export interface SidebarNavProps {
  navs?: NavItemData[];
  isExpanded?: boolean;
  isCollapsed?: boolean;
}

const SideBarNav = (props: SidebarNavProps) => {
  const { navs, isExpanded, isCollapsed } = props;

  let activeClassName = "sidebar-nav-item active";

  return (
    <div className="sidebar-nav">
      <nav className="sidebar-nav-content">
        <ul className="sidebar-nav-list">
          {navs?.map((item) => {
            const { children, ...rest } = item;

            if (children) {
              return (
                <li key={item.eventKey} className="sidebar-nav-group">
                  <NavLink
                    to={item.to}
                    className={({ isActive }) =>
                      isActive ? activeClassName : "sidebar-nav-item"
                    }
                  >
                    <Icon className="sidebar-nav-icon">{item.icon}</Icon>
                    {isExpanded && (
                      <span className="sidebar-nav-text">{item.title}</span>
                    )}
                    {isExpanded && (
                      <span className="sidebar-nav-arrow">▼</span>
                    )}
                  </NavLink>
                  {isExpanded && (
                    <ul className="sidebar-nav-submenu">
                      {children.map((child) => {
                        return (
                          <li key={child.eventKey}>
                            <NavLink
                              to={child.to}
                              className={({ isActive }) =>
                                isActive ? "sidebar-nav-subitem active" : "sidebar-nav-subitem"
                              }
                            >
                              <span className="sidebar-nav-text">{child.title}</span>
                            </NavLink>
                          </li>
                        );
                      })}
                    </ul>
                  )}
                </li>
              );
            }

            if (rest.target === "_blank") {
              return <></>;
            }

            return (
              <li key={item.eventKey} className="sidebar-nav-item-wrapper">
                <NavLink
                  to={item.to}
                  className={({ isActive }) =>
                    isActive ? activeClassName : "sidebar-nav-item"
                  }
                  title={!isExpanded ? item.title : undefined}
                >
                  <Icon className="sidebar-nav-icon">{item.icon}</Icon>
                  {isExpanded && (
                    <span className="sidebar-nav-text">{item.title}</span>
                  )}
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

export default SideBarNav;
